import React , {useEffect, useState} from "react";
import { BrowserView, ConsoleView, MobileView } from "react-device-detect";
import * as d3 from "d3";
import Streamgraph from "./Streamgraph.js";
import './styleSheets/App.css';
import './styleSheets/Streamgraph.css';
import "./styleSheets/SideGraph.css";
import "./styleSheets/Tooltip.css"

import dataPath from "./all_assets/Uni_Coll_1996_2020.csv";
import { filter } from "d3";

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

const collegeLogos = importAll(require.context('./all_assets/college_twitter_logos', false, /\.(png|jpe?g|svg|jfif)$/));
const universityLogos = importAll(require.context('./all_assets/university_twitter_logos', false, /\.(png|jpe?g|svg|jfif)$/));

function App() {

  const [allData,setAllData] = useState([]) // this is ALL of the data. Not necessarilly the input to the streamgraph
  const [inputData,setInputData] = useState([]) //this is the input to the streamgraph
  const [inputStat,setInputStat] = useState("Count") //this is the input stat to the streamgraph
  const [startYear,setStartYear] = useState(1996) //this is the start year to the streamgraph
  const [endYear,setEndYear] = useState(2020) //this is the end year to the streamgraph
  const[iconHoverID,setIconHoverID] = useState();

  useEffect(()=>{
    d3.csv(dataPath).then(function(parsedData){
      setAllData(parsedData)
      setInputData(parsedData)
    })
  },[])

  function imgHover(text,e){
    var existingTooltip = document.querySelector(".logo-tooltip");
    if(existingTooltip){existingTooltip.remove()}
    let base = document.createElement("div")
    var tip = document.createTextNode(text);
    base.classList.toggle("logo-tooltip")
    var windowWidth = window.innerWidth;
    var windowHeight= window.innerHeight;
    if (text!=null){
      setIconHoverID(text[0])
      base.innerHTML = "";
      base.appendChild(tip);
      var tipWidth;
      document.querySelector(".logo-tooltip") ? tipWidth = document.querySelector(".logo-tooltip").offsetWidth : tipWidth = 0
      var tipHeight;
      document.querySelector(".logo-tooltip") ? tipHeight = document.querySelector(".logo-tooltip").offsetHeight : tipHeight = 0
      var posX;
      e.pageX > 0.8*windowWidth ? posX = e.pageX - tipWidth - 80 : posX = e.pageX - 10
      var posY = e.pageY-20;
      base.style.position="absolute";
      base.style.left= (posX)+"px";
      base.style.top= (posY)+"px";
      document.body.appendChild(base)
    }
  }

  function imgClicker(text){
    var divID = text.replace(/[^A-Z0-9]/ig,"_")
    var element = document.getElementById(divID);
    if (element){
      console.log(element)
      if (element.classList.contains("deselect")){
        // console.log("ACTIVATED!!")
        element.classList.toggle("deselect")
        var selectedData = allData.filter((eachRecord)=>{return eachRecord['Employer']==text})
        var newInputData = inputData.concat(selectedData)
        setInputData(newInputData)
      }
      else{
        // console.log("DEACTIVATED!")
        element.classList.toggle("deselect")
        var newInputData = inputData.filter((eachRecord)=>{return eachRecord['Employer']!=text})
        setInputData(newInputData)
      }
  }}

  function allClicker(employerSector,selectType,sectorClassName){
    var allElements = document.getElementsByClassName(sectorClassName);
    for (var elementIndex = 0; elementIndex < allElements.length; elementIndex++){
      // console.log(allElements[elementIndex])
      if (selectType == "selectAll"){
          allElements[elementIndex].classList.remove("deselect")
          var chosenData = allData.filter((eachRecord)=>{return eachRecord['Sector']==employerSector})
          var removeIfData = inputData.filter((eachRecord)=>{return eachRecord['Sector']!=employerSector})
          var newInputData = chosenData.concat(removeIfData)
          setInputData(newInputData)
      }
      else{
        allElements[elementIndex].classList.add("deselect")
        var newInputData = inputData.filter((eachRecord)=>{return eachRecord['Sector']!=employerSector})
        // console.log("deselectAll",newInputData)
        setInputData(newInputData)
      }
    }
  }

  function toggleShow(sectorDivClassName){
    var allElements = document.getElementsByClassName(sectorDivClassName);
    // console.log(allElements)
    if (allElements[0]){
      allElements[0].classList.toggle("display")
    }
  }

  function checkIfAll(theClassName){
    // console.log(theClassName)
  }

  window.addEventListener('load',()=>{
    var showButtons = document.querySelectorAll(".toggle-show");
    showButtons.forEach((eachButton)=>{eachButton.innerHTML = "&#9650"})
  })

  return (
    <React.Fragment>

      <BrowserView viewClassName = "app browserView">
        <div className = "window-container browser">
          <div className= "header browser">
            <h3>25 years of Sunshine</h3>
            <hr className = "separator"></hr>
            <p> A Streamgraph Visualization of Sunshiners in Ontario's Universities and Colleges</p>
          </div>
          <div className = "stat-selector browser">
            <button className = "stat-button browser" onClick = {function(e){return setInputStat("Count")}}>Number of Employees</button>
            <button className = "stat-button browser" onClick = {function(e){return setInputStat("Total")}}>Total Income</button>
            <button className = "stat-button browser" onClick = {function(e){return setInputStat("Average")}}>Per-Capita Income</button>
          </div>
          <Streamgraph inputData = {inputData} stat = {inputStat} iconHoverID = {iconHoverID}/>
        </div>
        <div className = "controls-container browser">
          <div className = "university-logos browser">
            <div className = "logos-header browser">
              <button 
              className = "logos-title browser selected"
              onClick = {function(){
                var thisButton = document.querySelector(".university-logos").querySelector(".logos-title");
                if(thisButton.classList.contains("selected"))
                {
                  thisButton.classList.toggle("selected")
                  allClicker("Universities","deSelectAll","university-logo")
                }
                else{
                  thisButton.classList.toggle("selected")
                  allClicker("Universities","selectAll","university-logo")
                }
              }}
              >Universities</button>
            </div>
            <div className = "bunch-of-logos university-logos browser">
              {Object.keys(universityLogos).map(eachLogo=>{
                return(
                  <div 
                  className = 'one-logo university-logo browser' 
                  key = {eachLogo} 
                  id = {eachLogo.toString().split(".")[0].replace(/[^A-Z0-9]/ig,"_")}
                  onClick = {function(){
                    var text = eachLogo.toString().split(".")[0]
                    imgClicker(text);
                    // console.log("hahah")
                  }}
                  onMouseOver = {
                    function(e){
                      var text = eachLogo.toString().split(".").slice(0,1);
                      imgHover(text,e)
                    }
                  }
                  onMouseLeave = {
                    function(e){
                      document.querySelectorAll(".logo-tooltip").forEach(el => el.remove());
                    }
                  }
                  >
                <img src = {universityLogos[eachLogo]['default']}/>
                </div>
              )
            })}
            </div>
          </div>
          <div className = "college-logos browser">
            <div className = "logos-header browser">
              <button 
              className = "logos-title browser selected"
              onClick = {function(){
                var thisButton = document.querySelector(".college-logos").querySelector(".logos-title");
                if(thisButton.classList.contains("selected"))
                {
                  thisButton.classList.toggle("selected")
                  allClicker("Colleges","deSelectAll","college-logo")
                }
                else{
                  thisButton.classList.toggle("selected")
                  allClicker("Colleges","selectAll","college-logo")
                }
              }}
              >Colleges</button>
            </div>
            <div className = "bunch-of-logos college-logos browser">
              {Object.keys(collegeLogos).map(eachLogo=>{
                return(
                  <div 
                  className = 'one-logo college-logo browser' 
                key = {eachLogo} 
                id = {eachLogo.toString().split(".")[0].replace(/[^A-Z0-9]/ig,"_")}
                onClick = {function(){
                  var text = eachLogo.toString().split(".")[0]
                  imgClicker(text)
                }}
                onMouseOver = {
                  function(e){
                    var text = eachLogo.toString().split(".").slice(0,1);
                    imgHover(text,e)
                  }
                }
                onMouseLeave = {
                  function(e){
                    document.querySelectorAll(".logo-tooltip").forEach(el => el.remove());
                  }
                }
                >
                <img src = {collegeLogos[eachLogo]['default']}/>
                </div>
              )
            })}
            </div>
          </div>
        </div>
      </BrowserView>
      
      <MobileView viewClassName = "app mobileView">
        <div className = "header mobile">
          <h4>25 Years of Sunshine</h4>
          <p> A Streamgraph visualization of Sunshiners in Ontario's Universities and Colleges </p>
        </div>
        <div className = "controls-container mobile">
            <div className = "university-logos mobile">
              <div className = "logos-header mobile">
                <button 
                className = "logos-title mobile selected"
                onClick = {function(){
                  var thisButton = document.querySelector(".university-logos").querySelector(".logos-title");
                  if(thisButton.classList.contains("selected"))
                  {
                    thisButton.classList.toggle("selected")
                    allClicker("Universities","deSelectAll","university-logo")
                  }
                  else{
                    thisButton.classList.toggle("selected")
                    allClicker("Universities","selectAll","university-logo")
                  }
                }}
                >Universities</button>
                <button
                  className = "toggle-show showing mobile"
                  onClick = {function(){
                    var thisButton = document.querySelector(".university-logos").querySelector(".toggle-show");
                    if (thisButton.classList.contains("showing")){
                      thisButton.classList.toggle("showing")
                      thisButton.innerHTML = "&#9660"
                      toggleShow("bunch-of-logos university-logos")
                    }
                    else{
                      thisButton.classList.toggle("showing")
                      thisButton.innerHTML = "&#9650"
                      toggleShow("bunch-of-logos university-logos")
                    }
                  }}
                  >
                </button>
              </div>

              <div className = "bunch-of-logos university-logos mobile">
                {Object.keys(universityLogos).map(eachLogo=>{
                  return(
                    <div 
                    className = 'one-logo university-logo mobile' 
                    key = {eachLogo} 
                    id = {eachLogo.toString().split(".")[0].replace(/[^A-Z0-9]/ig,"_")}
                    onClick = {function(){
                      var text = eachLogo.toString().split(".")[0]
                      imgClicker(text)
                    }}
                    >
                  <img src = {universityLogos[eachLogo]['default']}/>
                  </div>
                )
              })}
              </div>
            </div>
            <div className = "college-logos mobile">
              <div className = "logos-header mobile">
                <button 
                className = "logos-title mobile selected"
                onClick = {function(){
                  var thisButton = document.querySelector(".college-logos").querySelector(".logos-title");
                  if(thisButton.classList.contains("selected"))
                  {
                    thisButton.classList.toggle("selected")
                    allClicker("Colleges","deSelectAll","college-logo")
                  }
                  else{
                    thisButton.classList.toggle("selected")
                    allClicker("Colleges","selectAll","college-logo")
                  }
                }}
                >Colleges</button>
                <button
                  className = "toggle-show showing mobile"
                  onClick = {function(){
                    var thisButton = document.querySelector(".college-logos").querySelector(".toggle-show");
                    if (thisButton.classList.contains("showing")){
                      thisButton.classList.toggle("showing");
                      thisButton.innerHTML = "&#9660"
                      toggleShow("bunch-of-logos college-logos")
                    }
                    else{
                      thisButton.innerHTML = "&#9650"
                      thisButton.classList.toggle("showing");
                      toggleShow("bunch-of-logos college-logos")
                    }
                  }}
                  >
                </button>
              </div>
              <div className = "bunch-of-logos college-logos mobile">
                {Object.keys(collegeLogos).map(eachLogo=>{
                  return(
                    <div 
                    className = 'one-logo college-logo mobile' 
                  key = {eachLogo} 
                  id = {eachLogo.toString().split(".")[0].replace(/[^A-Z0-9]/ig,"_")}
                  onClick = {function(){
                    var text = eachLogo.toString().split(".")[0]
                    imgClicker(text)
                  }}
                  >
                  <img src = {collegeLogos[eachLogo]['default']}/>
                  </div>
                )
              })}
              </div>
            </div>
          </div>
          <div className = "stat-selector mobile">
              <button className = "stat-button mobile" onClick = {function(e){return setInputStat("Count")}}>Number of Employees</button>
              <button className = "stat-button mobile" onClick = {function(e){return setInputStat("Total")}}>Total Income</button>
              <button className = "stat-button mobile" onClick = {function(e){return setInputStat("Average")}}>Per-Capita Income</button>
              {/* <select  onChange = {function(e){console.log(e.target.value);return setInputStat(e.target.value)}}>
                <option value = {"Count"}>{"Number of Employees"}</option>
                <option value = {"Total"}>{"Total Income of Employees"}</option>
              </select> */}
            </div>
          <Streamgraph inputData = {inputData} stat = {inputStat}/>
      </MobileView>

    </React.Fragment>
  );
}

export default App;
